











import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryNavigationList, DeleteNavigation } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import { NacigationStatusFormat,NavigationExpansionTypeFormat } from '@/utils/tyepconvert'
import CreateNavigationDialog from './CreateNavigationDialog.vue'
import UpdateNavigationDialog from './UpdateNavigationDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateNavigationDialog,
    UpdateNavigationDialog,
  },
})
export default class ActivityList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    platform: 0,
    channelId: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '客户端', param: 'platform', type: 'select', selectData: constant.BannerPlatform },
    { title: '展示位置', param: 'channelId', type: 'select', selectData: constant.NavigationChannelId },
    { title: '标题', param: 'title' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '新建导航栏', type: 'primary', click: this.createNavigation }]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '图标', param: 'icon', type:'image' },
    { title: '标题', param: 'title' },
    { title: '跳转地址', param: 'pageUrl' },
    { title: '状态', param: 'status', formatter: NacigationStatusFormat},
    { title: '扩展类型', param: 'expansionType', formatter: NavigationExpansionTypeFormat},
    { title: '排序', param: 'sort' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private createNavigation(){
    const d = this.$refs.CreateNavigationDialog as CreateNavigationDialog
    d.open(this.queryParam)
  }

  private openUpdate(data: any){
    const d = this.$refs.UpdateNavigationDialog as UpdateNavigationDialog
    d.open(data)
  }

  public async loadData() {
    const param: any = { ...this.queryParam }
    param.orderBy = "sort desc, create_time desc"
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryNavigationList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteNavigation({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
